import './applied_subtype_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.AppliedPostSourceTypeView extends Monitoring.Views.SocialContents.Filters.AppliedSubtypeView

  name: 'post_source_type'

  getAppliedValues: ->
    @searchQuery.get('post_source_type')

  removeFilter: (value) ->
    @searchQuery.removePostSourceType(value)
